import React from "react";
import { useParams } from "react-router-dom";

import caseStudies from "../data/caseStudies";
import CTASection from "../components/sections/CTASection";

function CaseStudyDetailPage() {
  const { slug } = useParams();

  const study = caseStudies.find((item) => item.slug === slug);

  if (!study) {
    return (
      <div
        style={{
          padding: "150px 20px",
          textAlign: "center",
        }}
      >
        <h1>Case Study Not Found</h1>
      </div>
    );
  }

  return (
    <>
      <section
        style={{
          background: "linear-gradient(135deg,#002147,#003d5c)",
          color: "#fff",
          padding: "140px 20px",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "14px",
              flexWrap: "wrap",
              marginBottom: "20px",
              alignItems: "center",
            }}
          >
            <span
              style={{
                color: "#21b573",
                fontWeight: 700,
                letterSpacing: ".08em",
                textTransform: "uppercase",
              }}
            >
              {study.industry}
            </span>

            {study.sourceTitle && (
              <span
                style={{
                  padding: "8px 14px",
                  borderRadius: "999px",
                  background: "rgba(255,255,255,0.12)",
                  color: "#fff",
                  fontSize: ".85rem",
                }}
              >
                Public reference
              </span>
            )}
          </div>

          <h1
            style={{
              fontSize: "clamp(3rem,5vw,5rem)",
              fontFamily: "Playfair Display, serif",
              marginBottom: "24px",
              lineHeight: 1.05,
            }}
          >
            {study.client}
          </h1>

          <p
            style={{
              color: "#e2e8f0",
              fontSize: "1.15rem",
              maxWidth: "800px",
              lineHeight: 1.9,
            }}
          >
            {study.challenge}
          </p>
        </div>
      </section>

      <section
        style={{
          padding: "60px 20px",
          background: "#f8fafc",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
            gap: "24px",
          }}
        >
          <div className="premium-card">
            <div style={{ padding: "24px" }}>
              <h4>Industry</h4>
              <p>{study.industry}</p>
            </div>
          </div>

          <div className="premium-card">
            <div style={{ padding: "24px" }}>
              <h4>Timeline</h4>
              <p>{study.timeline}</p>
            </div>
          </div>

          <div className="premium-card">
            <div style={{ padding: "24px" }}>
              <h4>Primary Outcome</h4>
              <p>{study.results[0]}</p>
            </div>
          </div>

          <div className="premium-card">
            <div style={{ padding: "24px" }}>
              <h4>Services</h4>
              <p>{study.servicesUsed.join(", ")}</p>
            </div>
          </div>
        </div>
      </section>

      <section
        style={{
          padding: "100px 20px",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          <div
            className="premium-card"
            style={{
              padding: "40px",
              marginBottom: "40px",
            }}
          >
            <h2 style={{ color: "#002147" }}>Challenge</h2>
            <p
              style={{
                color: "#6e6e73",
                lineHeight: 1.9,
              }}
            >
              {study.challenge}
            </p>
          </div>

          <div
            className="premium-card"
            style={{
              padding: "40px",
              marginBottom: "40px",
            }}
          >
            <h2 style={{ color: "#002147" }}>Strategy</h2>
            <p
              style={{
                color: "#6e6e73",
                lineHeight: 1.9,
              }}
            >
              {study.strategy}
            </p>
          </div>

          <div
            className="premium-card"
            style={{
              padding: "40px",
              marginBottom: "40px",
            }}
          >
            <h2 style={{ color: "#002147" }}>Execution</h2>
            <p
              style={{
                color: "#6e6e73",
                lineHeight: 1.9,
              }}
            >
              {study.execution}
            </p>
          </div>

          <div
            className="premium-card"
            style={{
              padding: "40px",
              marginBottom: study.sourceTitle ? "24px" : 0,
            }}
          >
            <h2 style={{ color: "#002147", marginBottom: "30px" }}>Results</h2>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
                gap: "20px",
              }}
            >
              {study.results.map((result) => (
                <div
                  key={result}
                  style={{
                    background: "#e9fff5",
                    padding: "24px",
                    borderRadius: "16px",
                    color: "#21b573",
                    fontWeight: 700,
                  }}
                >
                  {result}
                </div>
              ))}
            </div>
          </div>

          {study.sourceTitle && (
            <div
              className="premium-card"
              style={{
                padding: "28px 32px",
              }}
            >
              <h3 style={{ color: "#002147", marginBottom: "10px" }}>Public reference</h3>
              <p style={{ color: "#6e6e73", lineHeight: 1.8, marginBottom: "12px" }}>
                {study.sourceTitle}
              </p>
              {study.sourceUrl && (
                <a
                  href={study.sourceUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: "#21b573",
                    fontWeight: 700,
                    textDecoration: "none",
                  }}
                >
                  View source →
                </a>
              )}
            </div>
          )}
        </div>
      </section>

      <CTASection />
    </>
  );
}

export default CaseStudyDetailPage;
